module.exports = __webpack_public_path__ + "static/media/Norfolk-Serif.51af6089.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Norfolk-Serif.otf
// module id = 3322
// module chunks = 71